import { Purchases } from "./Purchases";

export const OrderConstants = {
  conflict: {
    orderTypes: {
      COOKIE_ORDER: "cookieOrder",
      ACCOUNT_ORDER: "accountOrder"
    },
    statuses: {
      CANCELED: "canceled"
    },
    EDIT_MODE: "editMode"
  },
  ORDER_ID_COOKIE_OLD: "ssb_order",
  ORDER_ID_COOKIE_NEW: "ytl.ws.order",
  purchases: Purchases
};

export const CUSTOMER_TYPE = {
  EXISTING_CUSTOMER: 'existingCustomer',
  NEW_CUSTOMER: 'newCustomer'
};
